<template>
	<v-form ref="form">
		<EgrantyTextInputField
			:disabled="readonly"
			v-model="internalName"
			:label="label"
			for="offer-name-input"
			id="offer-name-input"
		></EgrantyTextInputField>
	</v-form>
</template>

<script>
  import EgrantyTextInputField from "../../../../genericComponents/EgrantyTextInputField";

  export default {
    name: "OfferNameInput",

    components: {EgrantyTextInputField},

    methods: {
      validate() {
        return this.$refs['form'].validate();
      }
    },

    data() {
      return {
        internalName: ''
      };
    },

    watch: {
      name: {
        immediate: true,
        handler(value) {
          this.internalName = value;
        }
      },

      internalName: {
        immediate: true,
        handler(value) {
          this.$emit("update:name", value);
        }
      },
    },

    props: {
      name: {type: String, required: true},
      label: {type: String, required: true},
      readonly: {type: Boolean, default: false},
    },
  };
</script>

<style scoped>

</style>
